import { z } from 'zod';

// Aceita #RGB, #RGBA, #RRGGBB e #RRGGBBAA: o legado tem "#ffff" em contrastText (discovery/07 §3.2).
const hex = z.string().regex(/^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i);
const assetUrl = z.string().trim().regex(/^(https:\/\/|http:\/\/localhost[:/]|\/)/, 'logo só por https');
const optText = z.string().trim().min(1).nullish();

const legacyTone = z.looseObject({ main: hex.nullish() });
const legacyPalette = z.looseObject({ primary: legacyTone.nullish() }).nullish();
const themed = z.object({ light: assetUrl.optional(), dark: assetUrl.optional() });

/** Bloco novo e opcional (U16). Quando presente, vence as chaves legadas. */
export const brandBlockSchema = z.strictObject({
  name: z.string().trim().min(1).max(40).optional(),
  accent: hex.optional(),
  accentDark: hex.optional(),
  logo: themed.optional(),
  mark: themed.optional(),
  favicon: assetUrl.optional(),
});

/** O que a marca lê da config do corban: as chaves de hoje continuam valendo, `BRAND` é opcional. */
export const brandInputSchema = z.looseObject({
  MAIN_TITLE: optText,
  MAIN_LOGO: optText,
  INVERTED_LOGO: optText,
  MAIN_FAVICON: optText,
  MAIN_COLOR: z.string().nullish(),
  PALETTE: legacyPalette.catch(null),
  BRAND: brandBlockSchema.nullish(),
});

export type BrandBlock = z.infer<typeof brandBlockSchema>;
